import React, { forwardRef, useImperativeHandle, useState } from "react";
import styles from "./Modal.module.scss";
import { ReactComponent as Close } from "../../assets/icons/close.svg";
import Button from "../Button/Button";
import classNames from "classnames";

const Modal = forwardRef(
  (
    {
      children,
      title,
      onClose,
      maxWidth,
      marginTop,
      buttonOkText,
      buttonCloseText,
      buttonOkOnClick,
      buttonCloseOnClick,
      pendingAction,
      buttonOkDisabled,
      showCancelButton,
      showOkButton,
      modalStyle,
    },
    ref
  ) => {
    const [visible, setVisibility] = useState(false);

    useImperativeHandle(ref, () => ({
      show() {
        setVisibility(true);
      },
      hide() {
        setVisibility(false);
      },
    }));

    if (!visible) return null;

    return (
      <div className={styles.modal}>
        <div
          className={classNames(styles.modalContent, modalStyle)}
          style={{ maxWidth, marginTop }}
        >
          <div className={styles.modalHeader}>
            <p></p>
            <p className={styles.modalHeaderTitle}>{title}</p>
            <div className={styles.modalHeaderIconBox} onClick={onClose}>
              <Close style={{ transform: "rotate(-45deg)" }} />
            </div>
          </div>
          <div className={styles.modalContentInner}>{children}</div>

          <div className={styles.modalFooter}>
            {showCancelButton && (
              <Button
                onClick={buttonCloseOnClick}
                className={styles.modalFooterCloseButton}
                style={{ maxWidth: "30%" }}
                title={buttonCloseText}
                disabled={pendingAction}
              />
            )}
            {showOkButton && (
              <Button
                onClick={buttonOkOnClick}
                className={styles.modalFooterOkButton}
                style={{ maxWidth: "30%" }}
                title={buttonOkText}
                disabled={pendingAction || buttonOkDisabled}
                loading={pendingAction}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
);

Modal.defaultProps = {
  title: "Title",
  maxWidth: "50rem",
  marginTop: 0,
  buttonOkText: "Ok",
  buttonCloseText: "Close",
  showCancelButton: true,
  showOkButton: true,
  onClose: () => console.log(),
  buttonCloseOnClick: () => alert("CLOSE"),
  buttonOkOnClick: () => alert("Ok"),
};

export default Modal;
